import { useEffect } from "react";
import { useAuthStore } from "@/lib/stores/auth";

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const fetchUser = useAuthStore((state) => state.fetchUser);

  useEffect(() => {
    // Check auth status on app mount
    fetchUser();
  }, [fetchUser]);

  // Don't block rendering - let individual pages handle loading states
  return <>{children}</>;
}
